import gql from 'graphql-tag';

export const getCondominiumInfo = gql`
  query getCondominiumInfo($uuid: String!) {
    getCondominiumInfo(uuid: $uuid) {
      uuid
      name
      hasPostalServiceIntegration
      condominiumPersonContextId
      partnerPersonContextId
      geoCoordinates {
        latitude
        longitude
      }
      address {
        district
        city
        region
        country
        zipCode
        street
        number
        neighborhood
      }
      unityGroup {
        id
        name
        unity {
          id
          name
        }
      }
    }
  }
`;

export const getDeliveryReceipt = gql`
  query getDeliveryReceipt($uuid: String!) {
    getDeliveryReceipt(uuid: $uuid) {
      id
      packageDeliveryDate
      cameras
      cameraDetails {
        index
        isPorterVideo
      }
      condominium {
        name
        addressLine1
        addressLine2
      }
      unity {
        name
        group
      }
      deliveryPerson {
        phoneNumber
        cpf
      }
    }
  }
`;

export const getDeliveryReceiptCameraStream = gql`
  query getDeliveryReceiptCameraStream($uuid: String!, $cameraIndex: Int!) {
    getDeliveryReceiptCameraStream(uuid: $uuid, cameraIndex: $cameraIndex) {
      url
      status
      retryAfterSeconds
    }
  }
`;

export const getUnityInstruction = gql`
  query getUnityInstruction($unityId: String!) {
    getUnityInstruction(unityId: $unityId)
  }
`;

export const getCorreiosServiceDeliveryReceipt = gql`
  query getCorreiosServiceDeliveryReceipt($deliveryUuid: String!) {
    getCorreiosServiceDeliveryReceipt(deliveryUuid: $deliveryUuid) {
      deliveryDate
      condominium {
        name
        addressLine1
        addressLine2
      }
      unity {
        name
        group
      }
      geoCoordinates {
        latitude
        longitude
      }
      authenticator
    }
  }
`;
